import request from '@/utils/request';

const tencentMap = {
  // 获取腾讯地图 Key
  getTencentMapKey: () =>
    request('/ess/weixin/mp/getTencentMapKey', {
      method: 'get',
    }),
};

export default tencentMap;
